import { useState } from 'react';
import PaginationResponse from '../../../repositories/common/PaginationResponse';
import { PaginationDto } from '../../../api/dto/PaginationDto';

// 공통 Pagination 의 행 수 선택 기본값이 10 이라 맞춘다
export const DEFAULT_PAGE_SIZE = 10;

const useServerPaging = () => {
  const [page, setPage] = useState<PaginationResponse>({
    page: 1,
    size: DEFAULT_PAGE_SIZE,
    totalItemCount: 0,
    totalPageCount: 1,
  });

  const applyResult = (pagination: PaginationDto) =>
    setPage((prev) => ({
      ...prev,
      totalItemCount: pagination.totalCount,
      totalPageCount: Math.max(pagination.totalPages, 1),
    }));

  const resetToFirst = () => setPage((prev) => ({ ...prev, page: 1 }));

  return { page, setPage, applyResult, resetToFirst };
};

export default useServerPaging;
